import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    MenuItem,
    IconButton,
    InputAdornment
} from '@mui/material';
import { FaPlus, FaTrash } from 'react-icons/fa';
import SectionTitle from '../Common/Title';
import { saleTypes, vatRates } from '../../shared/Price';
import NumericField from '../Common/NumericField';

export default function PricingSection({ formData, setFormData }) {
    // Gestion des prix par type de vente
    const handlePriceChange = (index, field, value) => {
        const newPrices = [...formData.prices];
        newPrices[index] = {
            ...newPrices[index],
            [field]: value
        };
        setFormData(prev => ({ ...prev, prices: newPrices }));
    };

    const addPrice = () => {
        const newPrice = {
            type: saleTypes[0].id,
            vat: vatRates[0].value,
            priceTTC: 0,
            discountPriceTTC: null
        };
        setFormData(prev => ({
            ...prev,
            prices: [...prev.prices ?? [], newPrice]
        }));
    };

    const deletePrice = (index) => {
        const newPrices = formData.prices.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, prices: newPrices }));
    };

    return (
        <Box sx={{ mt: 3 }}>
            <SectionTitle>Tarification</SectionTitle>

            <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Type de vente</TableCell>
                            <TableCell>TVA</TableCell>
                            <TableCell>Prix TTC</TableCell>
                            <TableCell>Prix promo TTC</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(formData.prices ?? []).map((price, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <Select
                                        value={price.type}
                                        onChange={(e) => handlePriceChange(index, 'type', e.target.value)}
                                        fullWidth
                                        size="small"
                                    >
                                        {saleTypes.map((type) => (
                                            <MenuItem key={type.id} value={type.id}>
                                                {type.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </TableCell>
                                <TableCell>
                                    <Select
                                        value={price.vat}
                                        onChange={(e) => handlePriceChange(index, 'vat', e.target.value)}
                                        fullWidth
                                        size="small"
                                    >
                                        {vatRates.map((rate) => (
                                            <MenuItem key={rate.value} value={rate.value}>
                                                {rate.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </TableCell>
                                <TableCell>
                                    <NumericField
                                        type="number"
                                        value={price.priceTTC}
                                        onChange={(e) => handlePriceChange(index, 'priceTTC', parseFloat(e.target.value) || 0)}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                        }}
                                        size="small"
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell>
                                    <NumericField
                                        type="number"
                                        value={price.discountPriceTTC || ''}
                                        onChange={(e) => {
                                            const value = e.target.value === '' ? null : parseFloat(e.target.value);
                                            handlePriceChange(index, 'discountPriceTTC', value);
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                        }}
                                        size="small"
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell>
                                    {index !== 0 && (
                                        <IconButton onClick={() => deletePrice(index)} size="small">
                                            <FaTrash />
                                        </IconButton>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button 
                    startIcon={<FaPlus />} 
                    onClick={addPrice}
                    variant="outlined"
                >
                    Ajouter un prix
                </Button>
            </Box>

        </Box>
    );
}